/**
 * @file Buyerquest Initialize JS
 * Loops through bq.init and calls each method, also attaches to ajaxSuccess
 * to make all methods re-attach after any successful ajax call
 *
 * @author Michael Duff
 * @since 6.1.1
 * @version 1.0
 *
 * @example <caption>Example of adding method to intialize</caption>
 * bq.init.push(globalMethodName);
 */
bq.initializeJS = function() {
    if(bq.global.noInitJS) {
        return;
    }
    $.each(bq.init, function(){
        this.call();
    });
};

bq.initializeJS();
/*setTimeout(bq.initializeJS, 0);*/

$(document).bind('ajaxSuccess', bq.initializeJS);
$(document).bind('select2Inited', function (event, selector) {
    var index = bq.helper.waitingForInitSelect2List.indexOf(selector);
    if (index !== -1) {
        bq.helper.waitingForInitSelect2List.splice(index, 1);
    }

    if (bq.helper.waitingForInitSelect2List.length === 0) {
      bq.initializeJS();
    }
});
